// extracted by mini-css-extract-plugin
module.exports = {"collectionRail":"CollectionRail_collectionRail__h3GAm"};